<svg xmlns="http://www.w3.org/2000/svg" width="135" height="40" fill="none"
  ><rect width="134" height="39" x=".5" y=".5" fill="#000" rx="4.5" /><path
    fill="#fff"
    d="M68.137 21.7509c-2.352 0-4.269 1.789-4.269 4.253 0 2.449 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253-.001-2.464-1.918-4.253-4.27-4.253Zm0 6.832c-1.289 0-2.4-1.063-2.4-2.578 0-1.531 1.112-2.578 2.4-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.578-2.4 2.578Zm-9.314-6.832c-2.352 0-4.269 1.789-4.269 4.253 0 2.449 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253 0-2.464-1.917-4.253-4.27-4.253Zm0 6.832c-1.289 0-2.4-1.063-2.4-2.578 0-1.531 1.112-2.578 2.4-2.578 1.289 0 2.4 1.047 2.4 2.578.001 1.514-1.111 2.578-2.4 2.578Zm-11.078-5.526v1.804h4.318c-.129 1.015-.467 1.756-.983 2.271-.628.628-1.611 1.321-3.335 1.321-2.658 0-4.736-2.143-4.736-4.801 0-2.658 2.078-4.801 4.736-4.801 1.434 0 2.481.564 3.254 1.289l1.273-1.273c-1.08-1.031-2.513-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605 0 3.641 3.061 6.605 6.702 6.605 1.965 0 3.448-.645 4.607-1.853 1.192-1.192 1.563-2.868 1.563-4.221 0-.418-.032-.805-.097-1.127h-6.073v.001Zm45.308 1.401c-.354-.95-1.434-2.707-3.641-2.707-2.191 0-4.012 1.724-4.012 4.253 0 2.384 1.805 4.253 4.221 4.253 1.949 0 3.077-1.192 3.545-1.885l-1.45-.967c-.483.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.289l5.687-2.352-.193-.482Zm-5.8 1.418c-.048-1.644 1.273-2.481 2.224-2.481.741 0 1.369.371 1.579.902l-3.803 1.579Zm-4.623 4.124h1.868v-12.501H82.63v12.501Zm-3.062-7.298h-.064c-.419-.5-1.225-.951-2.239-.951-2.127 0-4.076 1.869-4.076 4.27 0 2.384 1.949 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.966h.064v.612c0 1.627-.87 2.497-2.271 2.497-1.144 0-1.853-.821-2.143-1.514l-1.627.677c.467 1.127 1.707 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.431v-7.636h-1.772v.692h-.001Zm-2.142 5.881c-1.289 0-2.368-1.08-2.368-2.562 0-1.499 1.079-2.594 2.368-2.594 1.272 0 2.271 1.095 2.271 2.594 0 1.482-.999 2.562-2.271 2.562Zm24.381-11.084h-4.471v12.501h1.865v-4.736h2.605c2.068 0 4.102-1.497 4.102-3.882s-2.033-3.883-4.101-3.883Zm.048 6.025h-2.654v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.143 0 .968-.792 2.142-2.187 2.142Zm11.532-1.795c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.014-.917 1.705-.917.965 0 1.946.579 1.962 1.608v.129c-.338-.193-1.062-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.254 0 1.946-.563 2.38-1.223h.064v.965h1.802v-4.793c.001-2.218-1.657-3.456-3.795-3.456Zm-.226 6.851c-.61 0-1.463-.306-1.463-1.062 0-.965 1.062-1.335 1.979-1.335.819 0 1.206.177 1.704.418-.145 1.159-1.142 1.979-2.22 1.979Zm10.583-6.578-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.946l5.131-11.789h-2.075Zm-16.806 7.998h1.865v-12.501h-1.865v12.501ZM47.4176 10.2432c0 .838-.248 1.505-.745 2.003-.564.592-1.3.888-2.204.888-.866 0-1.603-.3-2.208-.9-.606-.601-.909-1.345-.909-2.233 0-.88901.303-1.63301.909-2.23301.605-.601 1.342-.901 2.208-.901.43 0 .841.084 1.231.251.391.168.704.391.938.67l-.527.528c-.397-.475-.944-.712-1.643-.712-.632 0-1.178.222-1.639.666-.461.444-.691 1.021-.691 1.73001 0 .709.23 1.286.691 1.73.461.444 1.007.666 1.639.666.67 0 1.229-.223 1.676-.67.29-.291.458-.696.503-1.215h-2.179v-.72101h2.907c.03.157.043.30801.043.45301ZM52.0277 7.73724h-2.732v1.902h2.464v.72096h-2.464v1.902h2.732v.738h-3.503V7.00024h3.503v.737ZM55.2785 13.0002h-.771V7.73724h-1.676v-.737h4.123v.737h-1.676v5.26296ZM59.9375 13.0002V7.00024h.771v5.99996h-.771ZM64.1277 13.0002h-.771V7.73724h-1.676v-.737h4.123v.737h-1.676v5.26296ZM73.6084 12.2252c-.59.606-1.323.909-2.2.909-.877 0-1.61-.303-2.199-.909-.59-.606-.884-1.348-.884-2.225 0-.87697.294-1.61897.884-2.22497.589-.606 1.322-.91 2.199-.91.872 0 1.604.305 2.196.914.592.609.888 1.349.888 2.22097 0 .877-.295 1.619-.884 2.225Zm-3.83-.503c.444.45.987.674 1.63.674.643 0 1.187-.225 1.63-.674.444-.45.667-1.024.667-1.722 0-.69797-.223-1.27197-.667-1.72197-.443-.45-.987-.674-1.63-.674-.643 0-1.186.225-1.63.674-.443.45-.666 1.024-.666 1.72197 0 .698.223 1.272.666 1.722ZM75.5745 13.0002V7.00024h.938l2.916 4.66696h.033l-.033-1.156V7.00024h.771v5.99996h-.805l-3.051-4.89395h-.033l.033 1.15599v3.73796h-.769Z"
  /><path
    stroke="#fff"
    stroke-miterlimit="10"
    stroke-width=".2"
    d="M47.4176 10.2432c0 .838-.248 1.505-.745 2.003-.564.592-1.3.888-2.204.888-.866 0-1.603-.3-2.208-.9-.606-.601-.909-1.345-.909-2.233 0-.88901.303-1.63301.909-2.23301.605-.601 1.342-.901 2.208-.901.43 0 .841.084 1.231.251.391.168.704.391.938.67l-.527.528c-.397-.475-.944-.712-1.643-.712-.632 0-1.178.222-1.639.666-.461.444-.691 1.021-.691 1.73001 0 .709.23 1.286.691 1.73.461.444 1.007.666 1.639.666.67 0 1.229-.223 1.676-.67.29-.291.458-.696.503-1.215h-2.179v-.72101h2.907c.03.157.043.30801.043.45301ZM52.0277 7.73724h-2.732v1.902h2.464v.72096h-2.464v1.902h2.732v.738h-3.503V7.00024h3.503v.737ZM55.2785 13.0002h-.771V7.73724h-1.676v-.737h4.123v.737h-1.676v5.26296ZM59.9375 13.0002V7.00024h.771v5.99996h-.771ZM64.1277 13.0002h-.771V7.73724h-1.676v-.737h4.123v.737h-1.676v5.26296ZM73.6084 12.2252c-.59.606-1.323.909-2.2.909-.877 0-1.61-.303-2.199-.909-.59-.606-.884-1.348-.884-2.225 0-.87697.294-1.61897.884-2.22497.589-.606 1.322-.91 2.199-.91.872 0 1.604.305 2.196.914.592.609.888 1.349.888 2.22097 0 .877-.295 1.619-.884 2.225Zm-3.83-.503c.444.45.987.674 1.63.674.643 0 1.187-.225 1.63-.674.444-.45.667-1.024.667-1.722 0-.69797-.223-1.27197-.667-1.72197-.443-.45-.987-.674-1.63-.674-.643 0-1.186.225-1.63.674-.443.45-.666 1.024-.666 1.72197 0 .698.223 1.272.666 1.722ZM75.5745 13.0002V7.00024h.938l2.916 4.66696h.033l-.033-1.156V7.00024h.771v5.99996h-.805l-3.051-4.89395h-.033l.033 1.15599v3.73796h-.769Z"
  /><g filter="url(#a)"
    ><path
      fill="url(#b)"
      d="M10.4357 7.53833c-.291.308-.46304.786-.46304 1.405V31.0593c0 .62.17204 1.097.46304 1.405l.074.072 12.389-12.389v-.292L10.5097 7.46533l-.074.073Z"
    /><path
      fill="url(#c)"
      d="m27.0274 24.2781-4.129-4.131v-.292l4.13-4.13.093.053 4.893 2.78c1.397.794 1.397 2.093 0 2.888l-4.893 2.78-.094.052Z"
    /><g filter="url(#d)"
      ><path
        fill="url(#e)"
        d="m27.1235 24.225-4.224-4.224-12.462 12.463c.46.488 1.221.548 2.078.062l14.608-8.301Z"
      /></g
    ><path
      fill="url(#f)"
      d="m27.1235 15.7772-14.608-8.30001c-.857-.487-1.618-.426-2.078.062l12.463 12.46301 4.223-4.225Z"
    /></g
  ><rect width="134" height="39" x=".5" y=".5" stroke="#A6A6A6" rx="4.5" /><defs
    ><linearGradient
      id="b"
      x1="21.8005"
      x2="5.01846"
      y1="8.70933"
      y2="25.4913"
      gradientUnits="userSpaceOnUse"
      ><stop stop-color="#00A0FF" /><stop offset=".0066" stop-color="#00A1FF" /><stop
        offset=".2601"
        stop-color="#00BEFF"
      /><stop offset=".5122" stop-color="#00D2FF" /><stop
        offset=".7604"
        stop-color="#00DFFF"
      /><stop offset="1" stop-color="#00E3FF" /></linearGradient
    ><linearGradient
      id="c"
      x1="33.8329"
      x2="9.63704"
      y1="20.0011"
      y2="20.0011"
      gradientUnits="userSpaceOnUse"
      ><stop stop-color="#FFE000" /><stop offset=".4087" stop-color="#FFBD00" /><stop
        offset=".7754"
        stop-color="orange"
      /><stop offset="1" stop-color="#FF9C00" /></linearGradient
    ><linearGradient
      id="e"
      x1="24.8296"
      x2="2.0711"
      y1="22.2949"
      y2="45.0534"
      gradientUnits="userSpaceOnUse"
      ><stop stop-color="#FF3A44" /><stop offset="1" stop-color="#C31162" /></linearGradient
    ><linearGradient
      id="f"
      x1="7.2989"
      x2="17.4612"
      y1=".176989"
      y2="10.3393"
      gradientUnits="userSpaceOnUse"
      ><stop stop-color="#32A071" /><stop offset=".0685" stop-color="#2DA771" /><stop
        offset=".4762"
        stop-color="#15CF74"
      /><stop offset=".8009" stop-color="#06E775" /><stop
        offset="1"
        stop-color="#00F076"
      /></linearGradient
    ><filter
      id="a"
      width="23.0898"
      height="25.7207"
      x="9.97266"
      y="7.14111"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feBlend
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="-.15" /><feComposite
        in2="hardAlpha"
        k2="-1"
        k3="1"
        operator="arithmetic"
      /><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" /><feBlend
        in2="shape"
        result="effect1_innerShadow_1909_397"
      /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy=".15" /><feComposite
        in2="hardAlpha"
        k2="-1"
        k3="1"
        operator="arithmetic"
      /><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" /><feBlend
        in2="effect1_innerShadow_1909_397"
        result="effect2_innerShadow_1909_397"
      /></filter
    ><filter
      id="d"
      width="16.6875"
      height="12.8608"
      x="10.4375"
      y="20.001"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feBlend
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="-.15" /><feComposite
        in2="hardAlpha"
        k2="-1"
        k3="1"
        operator="arithmetic"
      /><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" /><feBlend
        in2="shape"
        result="effect1_innerShadow_1909_397"
      /></filter
    ></defs
  ></svg
>
